import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-branches',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox
  ],
  template: `
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox [(ngModel)]="field.enable_manual_input" binary="true"/>
        <label>{{ Yii.t('app', 'Enable manual input') }}</label>
      </div>
    </div>
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox [(ngModel)]="field.use_as_target_branch" binary="true"/>
        <label>{{ Yii.t('app', 'Use as target branch') }}</label>
      </div>
    </div>
  `,
})
export class FieldBranches {
  Yii = Yii;
  @Input() field: any;
}
